import { colors } from "hui";
import { Hamburger as HamburgerIcon } from "hui.icons";
import React, { useContext, useState } from "react";
import styled from "styled-components";
import HeaderContext from "../../HeaderContext";
import MenuContents from "./menu-contents";

const Menu = styled.div<{ breakPoint: string }>`
  display: inline-block;

  @media (min-width: ${props => props.breakPoint}) {
    display: none;
  }
`;

//dropdown nav menu for mobile/tablet
const MobileDropdown = styled.div<{ open: boolean, breakPoint: string }>`
  width: 100%;
  box-shadow: 0 6px 3px -3px rgba(0, 0, 0, 0.02);
  overflow: auto;
  zoom: 1;
  padding: 0 20px;
  transition: max-height 0.2s ease-in-out;
  max-height: ${props => (props.open ? 1000 : 0)}px;

  position: absolute;
  background: #fff;
  right: 0;
  z-index: 10;

  @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
    max-width: 375px;
  }

  @media (min-width: ${props => props.breakPoint}) {
    display: none;
  }
`;

const Hamburger = styled.a`
  padding: 26px 20px;
  padding-right: 0;
  font-size: 18px;
  color: #888;
  display: inline-block;
  cursor: pointer;
`;

const StyledHamburgerIcon = styled(HamburgerIcon)`
  fill: #888888;
  width: 21px;
  height: 18px;
`;

const UnreadMessagesCircle = styled.span`
  position: absolute;
  top: 19px;
  width: 13px;
  height: 13px;
  right: 13px;
  display: block;
  margin: 0;
  background-color: ${colors.danger};
  border: 2px solid ${colors.tint6};
  border-radius: 100%;
`;

type Props = {
  breakPoint: string;
  siteSource: string;
  loginData: { number_messages: number };
  hasSearch: boolean;
};

const HamburgerMenu: React.FC<{}> = () => {
  const { breakPoint, loginData } = useContext(HeaderContext);
  const [isOpen, setOpen] = useState(false);
  return (
    <Menu breakPoint={breakPoint}>
      {isOpen}
      <Hamburger onClick={() => setOpen(!isOpen)}>
        <StyledHamburgerIcon />
        {loginData && loginData.number_messages! > 0 && (
          <UnreadMessagesCircle />
        )}
      </Hamburger>

      <MobileDropdown open={isOpen} breakPoint={breakPoint}>
        <MenuContents isMobile />
      </MobileDropdown>
    </Menu>
  );
};

export default HamburgerMenu;
